export default __webpack_public_path__ + "static/media/bezos.e27faad8.jpg";